import { Button, DialogActions } from '@mui/material';

interface Props {
    onSubmit: () => void;
    onClose: () => void;
    submitDisabled: boolean;
}

export function DialogSubmitButtons({ onSubmit, onClose, submitDisabled }: Props) {
    return (
        <DialogActions>
            <Button color="secondary" variant="outlined" onClick={onClose}>
                Cancel
            </Button>
            <Button
                color="secondary"
                variant="contained"
                disabled={submitDisabled}
                onClick={onSubmit}
            >
                Submit
            </Button>
        </DialogActions>
    );
}
